import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
const VerifyCheckVerificationSuccess = (props) => {
    const selectVerifyCheckState = (state) => state.verifyCheck;
    const verifyCheckState = useSelector(selectVerifyCheckState);
    const dispatch = useDispatch();
    const processStateAction = (x) => ({ type: 'GOTO_PROCESS_STATE', processState: x });
    const submitData = (e) => {
        dispatch(processStateAction(e.currentTarget.value));
    };
    return React.createElement("div", null,
        React.createElement("div", null, "Check has been verified as a valid AutoCheck."),
        React.createElement("div", null, "Do you wish to adopt this Autocheck for the purpose of using the check to pay for a customer's vehicle?"),
        React.createElement("button", { className: "btn btn-primary", name: "btnAdopt", value: "adoptStart", onClick: submitData }, "Adopt"),
        React.createElement("button", { className: "btn btn-primary", name: "btnAdopt", value: "start", onClick: submitData }, "Cancel"));
};
//VerifyCheckVerificationSuccess.defaultProps = VerifyCheckStore.actionCreators;
export default VerifyCheckVerificationSuccess;
//# sourceMappingURL=VerifyCheckVerificationSuccess.js.map